import React from 'react'
import { Navbar } from 'react-bootstrap';
import IncomemaxLogo from '../images/incomemax-logo.svg';
import './footer.style.css';
const Footer = () => {


    return(
        <div style={{maxHeight: "207px"}}>
        <div className="footer-container">
            <Navbar.Brand className="footer-logo">

                <p  className="navTypography footer1 navTypography-footer" >
           Brought to you by {"\xa0"} <a style={{color: "#000"}} href="https://incomemax.org.uk/"> IncomeMax.org.uk</a>               
           </p>
        <p className="navTypography-footer">
        © 2025 IncomeMax. All rights reserved. 
        </p>
            </Navbar.Brand>
            <div className="footer-terms navTypography-footer">
                <a style={{color: "#000"}} href="https://incomemax.org.uk/privacy-policy/">Privacy Policy</a> 
                {"\xa0"}  <a style={{color: "#000"}} href="https://incomemax.org.uk/privacy-policy/">Terms & Conditions</a>
            </div>
        </div>
       

        </div>
    )
}

export default Footer;